import HotelNumber from '../HotelNumber'
import styles from './NumberList.module.scss'

const NumberList = ({ list, selectedNumbers, toggleNumber }) => {
  console.log({ list })

  if (!list) {
    return <p className={styles.beforeSearch}>Make a search to see numbers here</p>
  }

  if (list.length === 0) {
    return <span className={styles.noResults}>No results found for pattern</span>
  }

  return (
    <div>
      <span className={styles.select}>
        Select a <strong>single</strong> number
      </span>
      <div className={styles.list}>
        {list ? (
          list.map(({ number, location }) => (
            <HotelNumber
              key={number}
              number={number}
              location={location}
              toggleNumber={toggleNumber}
              checked={selectedNumbers.includes(number)}
            />
          ))
        ) : (
          <p className={styles.beforeSearch}>Make a search to see numbers here</p>
        )}
      </div>
    </div>
  )
}

export default NumberList
